<nb-card [nbSpinner]="true" nbSpinnerStatus="success">
    <nb-card-body>Autenticando... </nb-card-body>
</nb-card>
